// src/components/Footer.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import SocialLinks from './SocialLinks';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 mt-12">
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6">
            <p className="text-gray-600 dark:text-gray-300 text-sm">
              © {new Date().getFullYear()} Wildlifegamesonline. All rights reserved.
            </p>
            <div className="flex space-x-4">
              <Link 
                to="/about" 
                className="text-gray-600 hover:text-blue-600 dark:text-gray-300 dark:hover:text-blue-400 text-sm transition-colors"
              >
                About
              </Link>
              <Link 
                to="/terms" 
                className="text-gray-600 hover:text-blue-600 dark:text-gray-300 dark:hover:text-blue-400 text-sm transition-colors"
              >
                Terms
              </Link>
              <Link 
                to="/privacy" 
                className="text-gray-600 hover:text-blue-600 dark:text-gray-300 dark:hover:text-blue-400 text-sm transition-colors"
              >
                Privacy
              </Link>
            </div>
          </div>
          <div className="mt-4 md:mt-0">
            <SocialLinks />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;